import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import React, { PureComponent } from "react";

import { ReceivedDataState } from "altus-datastate";

import BasePage from "app/components/BasePage";
import NoContentBasePage from "app/components/NoContentBasePage";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { ACTIONS } from "features/planner/report/report.constants";
import { heliReportOnLoad } from "features/planner/report/report.actions";
import { getLocationGroupsFromState } from "features/planner/planner.selectors";
import { ACTIONS as PLANNER_ACTIONS } from "features/planner/planner.constants";
import HeliReportGroup from "features/planner/report/helicopter/components/HeliReportGroup";
import HelicopterIcon from "features/planner/report/helicopter/components/HelicopterIcon";

class HelicopterBookingReportContainer extends PureComponent {
  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  render() {
    const { groupId, dataState, breadcrumb, locationGroups } = this.props;

    if (!groupId) {
      return (
        <NoContentBasePage
          title={breadcrumb}
          Icon={HelicopterIcon}
          header="No location selected"
          description="Select a location in the top to start using the Helicopter Booking"
        />
      );
    }

    return (
      <BasePage title={breadcrumb} dataState={dataState}>
        <Grid container spacing={4}>
          <Grid item />
          <Grid container item>
            <HeliReportGroup
              key={groupId}
              groupId={groupId}
              locationGroups={locationGroups}
            />
          </Grid>
        </Grid>
      </BasePage>
    );
  }
}

HelicopterBookingReportContainer.defaultProps = {
  dataState: ReceivedDataState,
};

export default compose(
  connect(
    state => ({
      locationGroups: getLocationGroupsFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_HELI_REPORT,
        PLANNER_ACTIONS.GET_GROUPS,
      ),
    }),
    {
      dispatchOnLoad: heliReportOnLoad,
    },
  ),
)(HelicopterBookingReportContainer);
